import { Maximize2 } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const MaximizeIcon = DeckardIconWrapper({ Icon: Maximize2 });
